export default "__VITE_ASSET__f58ff7cf__"